/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request for a reviewer to change the status of a visit form.
 * @export
 * @interface ReviewerUpdateStatusRequest
 */
export interface ReviewerUpdateStatusRequest {
    /**
     * New status: 'complete', 'expired', or 'in_progress'
     * @type {string}
     * @memberof ReviewerUpdateStatusRequest
     */
    status: ReviewerUpdateStatusRequestStatusEnum;
    /**
     * Required reason for the status change
     * @type {string}
     * @memberof ReviewerUpdateStatusRequest
     */
    reason: string;
}


/**
 * @export
 */
export const ReviewerUpdateStatusRequestStatusEnum = {
    Complete: 'complete',
    Expired: 'expired',
    InProgress: 'in_progress'
} as const;
export type ReviewerUpdateStatusRequestStatusEnum = typeof ReviewerUpdateStatusRequestStatusEnum[keyof typeof ReviewerUpdateStatusRequestStatusEnum];


/**
 * Check if a given object implements the ReviewerUpdateStatusRequest interface.
 */
export function instanceOfReviewerUpdateStatusRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function ReviewerUpdateStatusRequestFromJSON(json: any): ReviewerUpdateStatusRequest {
    return ReviewerUpdateStatusRequestFromJSONTyped(json, false);
}

export function ReviewerUpdateStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewerUpdateStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'reason': json['reason'],
    };
}

export function ReviewerUpdateStatusRequestToJSON(value?: ReviewerUpdateStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'reason': value.reason,
    };
}

